import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { ApiService } from 'src/app/Services/api.service';
import { CommonServices } from 'src/app/Services/common.service';
import { ExcelExportService } from 'src/app/Services/excel.service';

@Component({
  selector: 'app-vehicle-audit-report',
  templateUrl: './vehicle-audit-report.component.html',
  styleUrls: ['./vehicle-audit-report.component.css']
})
export class VehicleAuditReportComponent implements OnInit {

  public tableData: any = [];
  public tableQuestions:any=[];
  public matFormSize = '12px';
  public vehicleAuditForm: FormGroup;
  public excelData: any = {};
  public enableTable:boolean = false;
  public vehicleShow :Boolean=false;
  public noDataFoundEnable:boolean=false;
  public showTable:boolean=true;
  public cols = [
    { key: '#', display: '#' },
    { key: 'vehRegNo', display:'Reg no', config: {
      isVehicle: true,
    },
    headerConfig:{ isDefault: true}
    },
    {
      key: 'driverName', display:'Driver name',headerConfig:{ isDefault: true}
    },
    {
      key: 'driverNumber', display:'Driver no',headerConfig:{ isDefault: true}
    },
    {
      key: 'action',
      display: 'Action',
      config: {
        isAction: true,
        actions: [
          { display: 'View', color: 'primary', icon: 'View' },
        
        ]
      }
    }
  ];

     
// pagination

  pageNum = 1;
  public showPagination: boolean = true;
  public paginationData = {
    page: 1,
    limit: 10,
    totalPage: 1,
  };
  public filterData = {};
  public maxDate = new Date();
  public errorObject: any = {
    date: '',
  }
  public vehicleData:any={};
  public vehicleAuditData:any=[];
  constructor(
    private dateAdapter: DateAdapter<Date>,
    public fb: FormBuilder,
    public com: CommonServices,
    public excel: ExcelExportService,
    public api:ApiService
      ) 
    {
      this.dateAdapter.setLocale('en-GB'); //dd/MM/yyyy
    }

    ngOnInit(): void {
    this.vehicleAuditFormsLoad();
      let obj={
       date: new Date(this.vehicleAuditForm.value.date).getTime()
      };
      this.getVehicleList(obj);
      this.getVehicleAuditReport();
    }

    getVehicleAuditReport(page: number = 1, limit = 10, filter = null,) {
    let obj = {page,limit,date:new Date(this.vehicleAuditForm.value.date).getTime(), }
    if (filter) {
      obj = {
        
        ...obj,
        ...filter,
      };
      this.filterData = { ...filter };
    }
    this.api.transportManagerVehicleAuditList(obj).then((res: any) => {
      if (res && res['status'] == 'success') {
        if (res['data'] && res['data'].length > 0) {
          this.processTableData(res.data);
          this.showTable = true;
          this.noDataFoundEnable = true;
          this.processPagination(res, obj);
        }
        else {
          this.tableData = [];
          this.showTable = true;
          this.noDataFoundEnable = true;
        }
        }
      }).catch((err) => {
        console.log('err', err);
      })
    }

  vehicleAuditFormsLoad() {
    this.vehicleAuditForm = this.fb.group({
     date:  new FormControl(new Date(), Validators.required),
    });
  }

  getVehicleList(obj,vehRegNo?){
  this.api.transportManagerVehicleAuditList(obj).then((res:any) =>{
    if (res.status == 'success') {
      if(res.data.length>0){
     
        this.processTableData(res.data);
      }else {
        this.tableData=[];
        this.noDataFoundEnable = true
      }
    }
    }).catch((err) => {
        console.log(err);
    });
  }

checkValidation() {
  let obj = {
    date: new Date(this.vehicleAuditForm.value.date).getTime()
  }
}

onSubmit() {
  let obj = {
    date: new Date(this.vehicleAuditForm.value.date).getTime()
  }
  this.getVehicleList(obj);
  this.getVehicleAuditReport(this.paginationData.page,this.paginationData.limit,obj);
}

processTableData(data) {
  this.showTable = true;
    this.tableData = data.map((res: any) => {
      let obj = {
        vehRegNo: res.vehRegNo,
        driverName:res.driverName,
        driverNumber:res.driverNumber,
        auditData:res.auditData['vehicle']
      }
      obj['auditData']=[
        ...obj['auditData'],
        ...res.auditData['driver']
      ];
      return obj;
      });
    }

    onActionHandler(e: any,data) {
      let modal=document.getElementById('vehicleAuditModal');
        if (e.action.display == 'View') {
          modal.style.display='block';
          this.showTable = true;
          this.vehicleData=e.data;
          let dataset=[
            ...e.data['auditData']]
          this.showQuestionsModal(dataset);
        }
    }

  showQuestionsModal(obj:any) {
   this.tableQuestions=  obj;
   if(this.vehicleData.length == 0)
   {
    this.tableQuestions=[];
    this.noDataFoundEnable = true;
   }
  }

  closePopup() {
    let modal=document.getElementById('vehicleAuditModal');
      modal.style.display='none';
      this.showTable = true;
  }

  setMaxDate() {
    let t_maxDate = new Date(this.vehicleAuditForm.controls.date.value);
    t_maxDate.setDate(t_maxDate.getDate() + 30);
  }

  processPagination(data, req) {
  this.showTable = false;
  this.paginationData = {
    page: req.page,
    limit: req.limit,
    totalPage: this.getTotalCount(data.totCnt, req.limit),
  }
  this.showTable = true;
  }

  getTotalCount(total, limit) {
    let result: any = 1;
    if (total / limit > 0) {
      result = total / limit;
      if (total % limit > 0) result++;
    }
    return Math.floor(result);
  }

  pagination(data) {
    let filterObj = Object.keys(this.filterData).length > 0 ? this.filterData : false;
    this.getVehicleAuditReport(data.page, data.limit, filterObj);  // (data.page,data.limit,'search') use third parameter to get results for search inputs
  }

// excel

public getVehNo: any = '';
public getdriverName:any='';
public getdriverNo:any='';
async exportToExcels(tableQuestions) {
  let rowCount = 2;   //2
  let endCell = 'C';
  let customizedData = [];
  let titleRow = {
    value: ['Vehicle Audit'],
    font: {
      name: 'Corbel', family: 4, size: 16, bold: true,
      color: { argb: 'FFFFFFFF' },
    },
    mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,// a1 - c2
    alignment: {
      cell: `A${(rowCount - 1) + ''}`, value: { vertical: 'middle', horizontal: 'center' },
    },
    fill: {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: '966462AF' },
      bgColor: { argb: 'FFF' }
    },
  }

  customizedData.push(titleRow);
  this.getVehNo = this.vehicleData['vehRegNo'];
  this.getdriverName=this.vehicleData['driverName'];
  this.getdriverNo=this.vehicleData['driverNumber'];
  this.vehicleAuditData=this.tableQuestions
  let vehicleQuestions=[];
  let vehicleResults=[];
  for(let j=0;j < this.vehicleAuditData.length;j++)
  {
    vehicleQuestions.push(this.vehicleAuditData[j]['Q']);
    vehicleResults.push(this.vehicleAuditData[j]['res']);
  }

    // SubTitleRow

    rowCount = rowCount + 3; 
    let subtitleRow = {
      value: [
        "Vehicle: " + (this.getVehNo?this.getVehNo:'---') + "\n" +
        "Driver name: "+ (this.getdriverName?this.getdriverName:'---') + "\n" +
        "Driver no: "+ (this.getdriverNo?this.getdriverNo:'---')+""
      ],
      font: { family: 4, size: 12 },
      mergeCells: `A${(rowCount - 2) + ''}:${endCell + rowCount + ''}`,
      border: {right: { style: 'thin' } },
    }
    customizedData.push(subtitleRow);
    rowCount=rowCount+1;

    let headerRow = {
        value:  ['S No','Questions', 'Result'] , 
        fill: {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFFFFF00' },
          bgColor: { argb: 'FF0000FF' }
        },
        font: { bold: true, size: 12 },
        border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } },
      }
      customizedData.push(headerRow);
      rowCount=rowCount+1;
      for(let k=0; k<vehicleQuestions.length;k++ ) {
        let itemq = vehicleQuestions[k];
        let  itemr= vehicleResults[k];
        try {
          let res = {
            value: [
              k + 1,
              itemq  ? itemq: '---',
              itemr !='null'  ? itemr : '---'
            ] 
          }
          customizedData.push(res);
        } catch (err) {
          console.log(err)
        }
      }

  let excelSheetName = 'vehicle Audit';
  if (this.excelData[excelSheetName] == undefined) { this.excelData[excelSheetName] = {}; }
  this.excelData[excelSheetName] = {
    customizedData: customizedData,
    data: {
      columWith: [{ colNo: 2, width: 40 }, { colNo: 3, width: 30 }, ]
    }
  };
  this.downloadExlReport();
  }

  downloadExlReport() {
    this.excel.generateExcel(this.excelData, 'Vehicle Audit Report'  + this.com.timestampToDate(new Date().getTime(),'DMY' )  + '.xlsx');
  }
}
